import type { InstagramShareFormValues } from './types';

import { createShareFormContext } from '~features/integrations/lib/createShareFormContext';

export const {
  ShareFormProvider: InstagramShareFormProvider,
  useShareForm: useInstagramShareForm,
} = createShareFormContext<InstagramShareFormValues>();
